<template>
    <div class="animated fadeIn">
        <div
            class="app-contentHeader"
        >
            <a
                class="kgr-button kgr-button--link"
                @click="redirectToOverview"
            >
                <kgr-icon
                    icon-class="arrow-left"
                    class="kgr-button__icon kgr-button__icon--left kgr-icon"
                />

                <span v-t="'backToOverview'"></span>
            </a>
            <kgr-button
                v-if="canCreate"
                @click="goToCreate"
            >
                <kgr-icon
                    icon-class="add"
                    small
                    circle
                    highlight
                    class="kgr-button__icon kgr-button__icon--left"
                />
                <span>{{ $t('Team erstellen') }}</span>
            </kgr-button>
        </div>
        <kgr-department-teams-data-provider
            v-slot="teamsScope"
            :department-id="departmentId"
        >
            <div>
                <kgr-empty-data
                    v-if="teamsScope.data.length === 0"
                    :value="$t('Keine Teams vorhanden')"
                />
                <table
                    v-else
                    class="kgr-table kgr-table--striped table-groups kgr-row kgr-table--block"
                >
                    <thead>
                        <tr class="kgr-table__row">
                            <th class="kgr-table__cell kgr-table__cell--headline team-image-col"></th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('name') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Mitglieder für andere sichtbar') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Team-Chat aktiviert') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Sportart') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(team, index) in teamsScope.data"
                            :key="index"
                            class="kgr-table__row"
                        >
                            <td class="kgr-table__cell team-image-col">
                                <div class="team-thumbnail">
                                    <img
                                        v-if="team.hasImage"
                                        :src="team.imageUrl"
                                        :alt="team.name"
                                        class="team-thumbnail__image"
                                    />
                                    <SphIcon v-else :icon="Camera" class="kgr-color kgr-color--gray" />
                                </div>
                            </td>
                            <td class="kgr-table__cell">
                                <kgr-team-name-link
                                    v-if="team.isBasicDataViewable"
                                    :team="team"
                                />
                                <span v-else>{{ team.name }}</span>
                            </td>
                            <td class="kgr-table__cell">
                                <span class="team-feature-label">
                                    <span v-if="!team.hideMembersFromEachOther">{{ $t('Ja') }}</span>
                                    <span v-else class="kgr-color kgr-color--gray">{{ $t('Nein') }}</span>
                                </span>
                            </td>
                            <td class="kgr-table__cell">
                                <span class="team-feature-label">
                                    <span v-if="team.enableChat">{{ $t('Ja') }}</span>
                                    <span v-else class="kgr-color kgr-color--gray">{{ $t('Nein') }}</span>
                                </span>
                            </td>
                            <td class="kgr-table__cell">
                                <span v-if="team.sportName">{{ team.sportName }}</span>
                                <span v-else class="kgr-color kgr-color--gray">–</span>
                            </td>
                            <td class="kgr-table__cell kgr-table__cell--actions">
                                <a
                                    v-if="team.isBasicDataEditable"
                                    :href="getEditUrl(team)"
                                    class="kgr-table__action"
                                    :title="$t('bearbeiten')"
                                >
                                    <kgr-icon-edit :size="15" />
                                </a>

                                <kgr-icon-delete
                                    v-if="team.isDeletable"
                                    class="kgr-table__action"
                                    @click="remove(team, teamsScope.reload, teamsScope.remove)"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </kgr-department-teams-data-provider>
    </div>
</template>

<script>
import {Camera} from 'lucide';
import DepartmentTeamsDataProvider from '../../components/data-provider/DepartmentTeamsDataProvider';
import EmptyData from '../../components/common/EmptyData';
import Icon from '../../components/common/icon/Icon';
import IconDelete from '../../components/common/icon/IconDelete';
import IconEdit from '../../components/common/icon/IconEdit';
import KgrButton from '../../components/common/form/button/KgrButton';
import KgrTeamNameLink from './TeamNameLink';
import {SphIcon} from '@/components/base/icon/index.ts';
import TeamRepository from '../../js/repository/TeamRepository';

export default {
    components: {
        KgrTeamNameLink,
        'kgr-department-teams-data-provider': DepartmentTeamsDataProvider,
        'kgr-empty-data': EmptyData,
        'kgr-button': KgrButton,
        'kgr-icon': Icon,
        'kgr-icon-delete': IconDelete,
        'kgr-icon-edit': IconEdit,
        SphIcon,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        departmentId: {
            type: Number,
            required: true,
        },
        canCreate: {
            type: Boolean,
            required: true,
        },
        createUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            Camera
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        goToCreate() {
            window.location = this.createUrl;
        },
        getEditUrl(team) {
            return `/backend/clubs/teams/${team.id}/basicData`;
        },
        remove(team, reload, remove) {
            showConfirm(this.$t('confirmInformal'), this.$t('team.confirm.delete', {'name': team.name}), () => {
                TeamRepository
                    .delete(team.id)
                    .then(() => {
                        remove(team);
                        this.$notify.success('team.delete.success', {'name': team.name});
                        reload();
                    })
                    .catch(error => {
                        if (error.status === 409) {
                            this.$notify.error('team.delete.conflict', {'name': team.name});
                        } else {
                            this.$notify.error('saveChanges.error')
                        }
                    });
            }, 'Ok');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.team-image-col {
    width: 50px;
    padding: 0.25rem !important;
}

.team-thumbnail {
    width: 80px;
    height: 80px;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    &__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
